import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/question-booking"

export const List = async (params) => {
    // using GET and passing params in query string since the controller uses req.query
    return await axiosInstance(options).get(`${path}/list`, { params });
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details/${id}`);
}

export const Status = async (id, status) => {
    return await axiosInstance(options).post(`${path}/update-status/${id}`, { status });
}

export const UploadReport = async (data) => {
    return await axiosInstance(options).post(`${path}/upload-report`, data);
}
